function debounce(fn, wait = 200) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}

async function fetchSection(url, sectionId) {
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const sep = url.includes('?') ? '&' : '?';
  const target = url.startsWith('http') ? url : root.replace(/\/$/, '') + url;
  const response = await fetch(`${target}${sep}section_id=${sectionId}`);
  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc;
}

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

const reveal = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        reveal.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.12 }
);
document.querySelectorAll('.rv').forEach((node) => reveal.observe(node));

function omtAnnounce(msg) {
  const el = document.getElementById('omt-live');
  if (!el) return;
  el.textContent = '';
  setTimeout(() => { el.textContent = msg; }, 60);
}

window.OMT = window.OMT || {};
window.OMT.debounce = debounce;
window.OMT.fetchSection = fetchSection;
window.OMT.prefersReducedMotion = prefersReducedMotion;
window.omtAnnounce = omtAnnounce;
